import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types
import mixins from "vue-typed-mixins";
// Components
import AdminButton from '../ui/AdminButton';
import CmsAltMenu from '../ui/CmsAltMenu';

// Utils
import { preventDefault } from '../../utils/jsxHelpers';
import consola from 'consola';

// Mixins
import { WithPartialInject } from '../../utils/withInject';
import { MoveDirection } from './EditorList';
import TicketInjector from '../../mixins/TicketInjector';
import { WithRefs } from '../../utils/withRefs';

// Enums
import { TicketProviders } from '../../enums/TicketProvider';
import { CmsAltMenuGroup } from '../../enums/CmsAltMenuGroup';
const EditorListItem = mixins(TicketInjector(TicketProviders.EditorList), WithRefs(), WithPartialInject('EditorListInstance')).extend({
  name: 'EditorListItem',
  props: {
    itemId: {
      type: Number,
      default: null
    }
  },
  computed: {
    itemIndex() {
      var _this$EditorListInsta, _this$EditorListInsta2;
      const index = (_this$EditorListInsta = this.EditorListInstance) === null || _this$EditorListInsta === void 0 ? void 0 : (_this$EditorListInsta2 = _this$EditorListInsta.computedValue) === null || _this$EditorListInsta2 === void 0 ? void 0 : _this$EditorListInsta2.findIndex(item => item.$id === this.itemId);
      return (index !== null && index !== void 0 ? index : this.ticket) || 0;
    }
  },
  mounted() {
    if (this.itemId === null) {
      consola.error('itemId prop not defined on following component:', this.$el, '\n\nHint: <editor-list-item :item-id="item.$id">');
    }
  },
  render() {
    var _this$$scopedSlots$de, _this$$scopedSlots;
    const h = arguments[0];
    const {
      itemIndex
    } = this;
    const {
      items = [],
      itemClass,
      createForm,
      updateItem,
      itemOptions,
      genField,
      moveItem,
      removeItem,
      imageOptionNames = []
    } = this.EditorListInstance || {};
    return itemIndex === null ? h("div") : h("div", {
      "class": ['relative', itemClass]
    }, [(_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots).default) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {}), h(CmsAltMenu, {
      "attrs": {
        "disabled": !this.$isInEditMode,
        "group": CmsAltMenuGroup.EditorList,
        "disableClickOutside": true
      },
      "on": {
        "opened": () => createForm === null || createForm === void 0 ? void 0 : createForm(itemIndex)
      },
      "scopedSlots": {
        opener: () => h("button", _mergeJSXProps([{
          "ref": 'editButton',
          "refInFor": true
        }, {
          directives: [{
            name: 'show',
            value: this.$isInEditMode
          }]
        }, {
          "attrs": {
            "type": "button"
          },
          "class": "absolute top-0 right-0 p-1 w-8 h-8 bg-white"
        }]), [h("em", {
          "class": "core-icon-edit"
        })]),
        default: ({
          close,
          reposition
        }) => h("form", {
          "class": 'p-2 bg-white rounded-md shadow-lg border border-gray-300',
          "style": "width: 600px",
          "on": {
            "submit": preventDefault(() => (updateItem === null || updateItem === void 0 ? void 0 : updateItem(itemIndex)) && close())
          }
        }, [itemOptions === null || itemOptions === void 0 ? void 0 : itemOptions.map(options => genField === null || genField === void 0 ? void 0 : genField(options, itemIndex)), h("div", {
          "class": "flex space-x-4 p-2 items-center justify-between"
        }, [h("div", {
          "class": "space-x-4 flex"
        }, [h(AdminButton, {
          "attrs": {
            "secondary": true,
            "icon": true,
            "disabled": itemIndex === 0
          },
          "on": {
            "click": () => (moveItem === null || moveItem === void 0 ? void 0 : moveItem(itemIndex, MoveDirection.Backward)) && this.$nextTick(() => reposition())
          }
        }, [h("em", {
          "class": "core-icon-arrow-left"
        })]), h("span", [this.$at('core.action.move')]), h(AdminButton, {
          "attrs": {
            "secondary": true,
            "icon": true,
            "disabled": itemIndex >= items.length - 1
          },
          "on": {
            "click": () => (moveItem === null || moveItem === void 0 ? void 0 : moveItem(itemIndex, MoveDirection.Forward)) && this.$nextTick(() => reposition())
          }
        }, [h("em", {
          "class": "core-icon-arrow-right"
        })]), h(AdminButton, {
          "attrs": {
            "error": true
          },
          "on": {
            "click": () => (removeItem === null || removeItem === void 0 ? void 0 : removeItem(itemIndex)) && close()
          }
        }, [this.$at('core.action.delete')])]), h("div", {
          "class": "space-x-4 flex"
        }, [h(AdminButton, {
          "attrs": {
            "secondary": true
          },
          "on": {
            "click": () => close()
          }
        }, [this.$at('core.action.cancel')]), h(AdminButton, _mergeJSXProps2([{
          "ref": 'lastElement' + itemIndex,
          "attrs": {
            "type": 'submit'
          }
        }, {
          "nativeOn": {
            keydown: e => {
              if (!e.shiftKey && e.code === 'Tab') {
                var _this$$refs;
                e.preventDefault();
                (_this$$refs = this.$refs['firstElement' + itemIndex]) === null || _this$$refs === void 0 ? void 0 : _this$$refs.focus();
              }
            }
          }
        }]), [this.$at('core.action.save')])])])])
      }
    })]);
  }
});
export default EditorListItem;